var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/classof-raw.js
// module id = 155
// module chunks = 0